




































































































import { ContractTypeEnum } from "@/lib/enum/contract-type.enum";
import { handleError } from "@/lib/utility/handleError";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { Contract, IContract } from "@/models/contract.entity";
import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";
import TemplateEditor from "../template/TemplateEditor.vue";
import RefsSelectForm from "../utility/RefsSelectForm.vue";
import InsuranceContractForm from "./InsuranceContractForm.vue";
import WorkshopContractForm from "./WorkshopContractForm.vue";
import CustomerContractForm from "./CustomerContractForm.vue";
import MIconButton from "../utility/mmmint/MIconButton.vue";
import { BackendResourceEnum, ResourceEnum } from "@/store/enum/authResourceEnum";
import { ActivityLog } from "@/models/activity-log.entity";

@Component({
  components: {
    TemplateEditor,
    RefsSelectForm,
    InsuranceContractForm,
    WorkshopContractForm,
    CustomerContractForm,
    MIconButton
  }
})
export default class ContractDetailsForm extends mixins(RulesMixin) {
  @Prop({ required: true }) contract!: IContract;
  @Prop({ default: false }) valid!: boolean;

  local: IContract = new Contract({});
  original: IContract = new Contract({});
  localValid = false;
  isEditing = false;
  loading = false;
  changedFields: string[] = [];

  readonly contracTypeEnum = ContractTypeEnum;
  readonly ResourceEnum = ResourceEnum;

  @Watch("contract", { immediate: true, deep: true })
  onContractChange(val: IContract) {
    this.local = new Contract(val);
    this.original = new Contract(val);
    this.changedFields = []; // Reset changed fields when contract changes
  }

  @Watch("localValid")
  onLocalValid(val: boolean) {
    this.$emit("update:valid", val);
  }

  @Watch("valid")
  onExternalValid(val: boolean) {
    if (val !== this.localValid) {
      this.localValid = val;
    }
  }

  updateDetails(details: any) {
    this.local.details = details;
  }

  onChanged(labelKey: string) {
    if (!this.isEditing) return;

    // Add to changed fields if not already present (store the key, not the translated text)
    if (!this.changedFields.includes(labelKey)) {
      this.changedFields.push(labelKey);
    }
  }

  onChildFormChanged(labelKey: string) {
    this.onChanged(labelKey);
  }

  cancelEdit() {
    this.local = new Contract(this.original);
    this.isEditing = false;
    this.changedFields = []; // Reset changed fields on cancel
  }

  async update() {
    this.loading = true;
    try {
      await this.local.update();
      this.$emit("updated", this.local);

      // Create activity log if there are changes
      if (this.changedFields.length > 0) {
        await this.createActivityLog(this.changedFields);
      }

      this.original = new Contract(this.local);
      this.isEditing = false;
      this.changedFields = []; // Reset changed fields after successful update
      this.$toast.success("👍");
    } catch (e) {
      handleError(e);
    } finally {
      this.loading = false;
    }
  }

  async createActivityLog(changedFields: string[]) {
    await new ActivityLog().createManagePropertiesLog({
      source: { refId: this.local.id, refType: BackendResourceEnum.CONTRACT },
      partnerId: this.local.partnerId,
      keys: changedFields
    });
  }
}
